/* eslint-disable angular/document-service */
import { RenderCtrl } from "../shared/render.component";
class RenderDynamicCtrl extends RenderCtrl {
  constructor(
    $compile, $element, $scope,
    RenderService, BehaviorService
  ) {
    'ngInject';
    super(RenderService, $scope);

    this.$element = $element;
    this.$compile = $compile;
    this.bs = BehaviorService;
  }

  get blockIds() { 
    this._blockIds = this._blockIds || this.ts.getDynamicTemplateBlockIds();
    return this._blockIds;
  }

  async $onInit() {
    try {
      await super.$onInit();
      if (!this.td) return;
      this.bindDynamicEvents();
      this.setPageStyles();
      this.loadDynamicContent();
    } catch (error) {
      this.handleError(error);
    }
  }

  bindDynamicEvents() {
    this.es.subscribeEvent( // fires first on 'all controls loaded'
      this.es.actions.RECORDS_UPDATED,
      () => this.onDynamicRecordsChanged(),
      `RECORDS_UPDATED_DYN`
    );
    this.es.subscribeEvent(
      this.es.actions.DOWNLOAD_REPORT, 
      event => this.downloadReport(event),
      'DOWNLOAD_REPORT_DYN');
  }

  setPageStyles() {
    // Layout styles
    let match;
    const layoutStyles = {};
    const regex = /([\w-]*)\s*:\s*([^;]*)/g;
    // eslint-disable-next-line no-cond-assign
    while (match = regex.exec(this.td.template.layout)) {
      const p = match[1].toLowerCase();
      layoutStyles[p] = match[2].trim();
    }

    const pageStyles = this.tb.getDynamicPageDims(this.td.template.layout);

    // Margin styles
    const marginStyles = { 
      'margin-top': `${pageStyles.margins.top}`, 
      'margin-bottom': `${pageStyles.margins.bottom}`,
      'margin-left': `${pageStyles.margins.left}`,
      'margin-right': `${pageStyles.margins.right}`
    };

    // Render container styles (when not printing)
    const containerStyles = { 
      ...layoutStyles,
      width: pageStyles.innerWidth, 
      ...marginStyles
    };

    // Get style tag css strings
    const getObjCss = (obj, important) => {
      const skip = ['height'];
      let css = Object.keys(obj)
        .filter(k => !skip.includes(k))
        .map(k => `${k}: ${obj[k]}${important ? ' !important;': ';'}`)
        .join('\n');  
      return css || '';
    };
    let marginCss = getObjCss(marginStyles, true);
    this.containerCss = getObjCss(containerStyles);

    this.pagePrintStyles = `size: ${pageStyles.width} ${pageStyles.height}; ${marginCss}`;
    this.completerStyles = `#page-wrapper { min-height: ${pageStyles.height}; }`;
  }

  loadDynamicContent() {
    if (this._dynamicContentLoaded) return;
    this._dynamicContentLoaded = true;

    const cleanContent = this.purgeContent(this.td.template.content);
    const templateDom = angular.element(`<div>${cleanContent}</div>`);
    const tokenElements = templateDom.find(".fe-token, .fe-report") || [];
    tokenElements.map((idx, el) => {
      const {tokenId} = el.dataset;
      const token = this.ts.tokens.find(t => t.id == tokenId);
      const transcluded = el.innerHTML;
      if (!token || !this.ts.references.find(r => r.id == token.referenceId)) {
        // TODO: should we remove HTML of tokens with no reference?
        return;
      }
      const feCtrl = this.renderControl(token, el, transcluded);
      el.outerHTML = feCtrl;
    });

    this.$scope.$apply();

    this.$timeout(_ => {
      // Clear before append — old code only appended and stacked duplicate HTML on remount.
      const $content = this.$element.find("#render-content");
      $content.empty();
      // span wrapper prevent error compiling non html tag roots
      $content.append(this.$compile(`<span>${templateDom.html()}</span>`)(this.$scope));
    });
  }

  downloadReport(event) {
    const repTokenId = event.target.getAttribute("data-token-id");
    const reportCtrl = angular.element(document.querySelector(`fe-control.token-id-${repTokenId} report-control`)).isolateScope().$ctrl;
    const fields = reportCtrl.token.control.reportTableSchema.fields;
    const recs = reportCtrl.reportRecs?.filter(r => r._class.contains("report-item"));
    const filename = `${reportCtrl.fieldSchema?.label || 'report'}.csv`;

    let csvArray = [];
    if (!recs.length) return;
    recs.forEach((r, i) => {
      if (i == 0) 
        csvArray.push(reportCtrl.reportFieldIds
          .map(fId => decodeURIComponent(fields.find(f => f.id == fId)?.label || '?')));
      csvArray.push(reportCtrl.reportFieldIds.map(fId => r[fId].display.toString() || ''));
    });

    const csvContent = csvArray.reduce((content, rowArray) =>
      content + rowArray.map(entry => `"${entry.replace(/"/g, '""')}"`).join(',') + "\r\n", '');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  purgeContent(content) {
    // Remove invalid MS word @page styles from css
    let newContent = content
      .replace(/@page\sWordSection[^}^{]*\{[^}]*\}/gm, '')
      .replace(/\{page:[\s]*WordSection[^}]*\}/gm, '{}');
    return newContent;
  }

  renderControl(token, element, transcluded = "") {
    if (!this.rcs.recordReferences.find(r => r.id === token.referenceId)) 
      return '<span class="fe-control-missing-table"></span>';
    // If style.width is 'auto', we set it to its initial config
    let cStyle = (token.control.defaultCss || '') + (element.attributes.style?.value.replace(/["]+/g, "'") || '');
    // reference-field class: ref-[REF_ID]-fid-[FIELD-ID]:
    let cClass = `${this.rs.referenceFieldId(token)} ${token.control.type} ${element.attributes.class?.value.replace(/["]+/g, "'") || ''} `;
    cClass += `token-id-${token.id}`;
    cClass += ` fe-${token.control.type}`;
    if (!this.printing) {
      token._cssObj = this.tb.getCssObj(cStyle);
      cStyle = this.tb.getDynamicTokenLayout(this.td.template.layout, token, {...token._cssObj});
    }
    
    return `<fe-control 
      ng-if="$ctrl.controlModelsReady"
      token-id="'${ token.id }'" 
      style="${ cStyle }"
      class="${ cClass }"
      model="$ctrl.rcs.records['${token.referenceId}']['${token.fieldId}']"
      >
        ${transcluded}
      </fe-control>`;
  }
  
  onDynamicRecordsChanged() {
    this.blockIds.forEach(id => {
      const visible = this.bs.evalVisibleBehavior(id);
      visible ? $(`[data-block-id="${id}"]`).show() : $(`[data-block-id="${id}"]`).hide();
    });
  }
}


export default {
  bindings: {},
  templateUrl: "form-render/render-dynamic/render-dynamic.component.html",
  controller: RenderDynamicCtrl
}
